import { Link } from 'react-router-dom';
import { Check, Clock, Sparkles } from 'lucide-react';
import type { Package, VehicleClass } from '../lib/types';
import { durationLabel, money } from '../lib/format';

export default function PackageCard({
  pkg,
  vehicleClass,
  compact = false,
}: {
  pkg: Package;
  vehicleClass: VehicleClass;
  compact?: boolean;
}) {
  const price = pkg.prices[vehicleClass] ?? pkg.prices.car;
  return (
    <div
      className={`card glass-hover relative flex h-full flex-col p-6 ${
        pkg.popular ? 'border-accent-500/50 shadow-[0_0_50px_-15px_rgba(14,165,233,0.45)]' : ''
      }`}
    >
      {pkg.popular && (
        <span className="absolute -top-3 left-6 flex items-center gap-1 rounded-full bg-gradient-to-r from-accent-600 to-sky-500 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white">
          <Sparkles size={12} /> Most Popular
        </span>
      )}
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-display text-xl font-bold text-white">{pkg.name}</h3>
          <span className="mt-1 flex items-center gap-1.5 text-xs text-zinc-500">
            <Clock size={12} /> {durationLabel(pkg.durationHours)}
          </span>
        </div>
        <div className="text-right">
          <div className="font-display text-2xl font-extrabold text-white">{money(price)}</div>
          <div className="text-[11px] uppercase tracking-wide text-zinc-500">
            {pkg.category === 'full' ? 'in & out' : pkg.category}
          </div>
        </div>
      </div>

      <p className="mt-3 text-sm leading-relaxed text-zinc-400">{pkg.description}</p>

      <ul className="mt-4 flex-1 space-y-2">
        {(compact ? pkg.features.slice(0, 4) : pkg.features).map((f, i) => (
          <li key={i} className="flex items-start gap-2.5 text-sm text-zinc-300">
            <Check size={15} className="mt-0.5 shrink-0 text-accent-400" />
            {f}
          </li>
        ))}
        {compact && pkg.features.length > 4 && (
          <li className="pl-6 text-sm text-zinc-500">+ {pkg.features.length - 4} more…</li>
        )}
      </ul>

      <Link
        to={`/booking?package=${pkg.id}&vehicle=${vehicleClass}`}
        className={`${pkg.popular ? 'btn-primary' : 'btn-ghost'} mt-6 w-full text-sm`}
      >
        Book {pkg.name}
      </Link>
    </div>
  );
}
